import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatTabsModule } from "@angular/material/tabs";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTableModule } from "@angular/material/table";
import { MatChipsModule } from "@angular/material/chips";
import { MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatOptionModule } from "@angular/material/core";
import { MatDividerModule } from "@angular/material/divider";
import { MatSnackBarModule } from "@angular/material/snack-bar";

@NgModule({
	exports: [
		MatButtonModule,
		MatIconModule,
		MatListModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatSelectModule,
		MatRadioModule,
		MatInputModule,
		MatMenuModule,
		MatProgressSpinnerModule,
		MatSlideToggleModule,
		MatCardModule,
		MatSidenavModule,
		MatToolbarModule,
		MatSortModule,
		MatDialogModule,
		MatExpansionModule,
		MatTabsModule,
		MatGridListModule,
		MatTableModule,
		MatChipsModule,
		MatRippleModule,
		MatDatepickerModule,
		MatOptionModule,
		MatSnackBarModule,
		MatDividerModule,
	],
})
export class MaterialModule {}
